/** Defer work until the browser is idle to improve LCP (feed and above-the-fold). */
export default function scheduleIdle(fn, timeout = 2500) {
  if (typeof window === 'undefined') {
    fn()
    return () => {}
  }
  if ('requestIdleCallback' in window) {
    const id = window.requestIdleCallback(fn, { timeout })
    return () => window.cancelIdleCallback?.(id)
  }
  const t = window.setTimeout(fn, 1)
  return () => window.clearTimeout(t)
}
